import { c as _c } from "react/compiler-runtime";
import type { CountryRecord, L10n } from '@onefootprint/core';
import { Button, PhoneInput } from '@onefootprint/ui';
import { Controller, useForm } from 'react-hook-form';
type PhoneFormData = {
  phoneNumber: string;
};
type PhoneFormProps = {
  defaultPhone?: string;
  isLoading?: boolean;
  l10n?: L10n;
  onSubmit: (formData: PhoneFormData) => void;
  options?: CountryRecord[];
  validator?: (phone: string) => boolean;
  texts: {
    cta: string;
    phoneInvalid: string;
    phoneLabel: string;
    phoneRequired: string;
  };
};
const PhoneForm = t0 => {
  const $ = _c(29);
  const {
    defaultPhone,
    isLoading,
    l10n,
    onSubmit,
    options,
    texts,
    validator
  } = t0;
  let t1;
  if ($[0] !== defaultPhone) {
    t1 = {
      defaultValues: {
        phoneNumber: defaultPhone
      }
    };
    $[0] = defaultPhone;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    control,
    setValue,
    handleSubmit,
    setError,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  const hasError = !!errors.phoneNumber;
  const hint = hasError ? errors.phoneNumber?.message : undefined;
  let t3;
  if ($[2] !== onSubmit || $[3] !== setError || $[4] !== texts.phoneInvalid || $[5] !== validator) {
    t3 = formData => {
      if (validator && !validator(formData.phoneNumber)) {
        setError("phoneNumber", {
          message: texts.phoneInvalid
        }, {
          shouldFocus: true
        });
        return;
      }
      onSubmit(formData);
    };
    $[2] = onSubmit;
    $[3] = setError;
    $[4] = texts.phoneInvalid;
    $[5] = validator;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleBeforeSubmit = t3;
  let t4;
  if ($[7] !== handleBeforeSubmit || $[8] !== handleSubmit) {
    t4 = handleSubmit(handleBeforeSubmit);
    $[7] = handleBeforeSubmit;
    $[8] = handleSubmit;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== texts.phoneRequired) {
    t5 = {
      required: {
        value: true,
        message: texts.phoneRequired
      }
    };
    $[10] = texts.phoneRequired;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hint || $[13] !== l10n?.locale || $[14] !== options || $[15] !== setValue || $[16] !== texts.phoneLabel) {
    t6 = t7 => {
      const {
        field: t8,
        fieldState: t9
      } = t7;
      const {
        onChange,
        onBlur,
        value,
        name
      } = t8;
      const {
        error
      } = t9;
      return <PhoneInput autoFocus={true} data-nid-target="phone-number" data-dd-privacy="mask" hasError={!!error} hint={hint} label={texts.phoneLabel} locale={l10n?.locale} name={name} onBlur={onBlur} onChange={onChange} onReset={() => {
        setValue("phoneNumber", "");
      }} options={options} value={value} />;
    };
    $[12] = hint;
    $[13] = l10n?.locale;
    $[14] = options;
    $[15] = setValue;
    $[16] = texts.phoneLabel;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== control || $[19] !== t5 || $[20] !== t6) {
    t7 = <Controller control={control} name="phoneNumber" rules={t5} render={t6} />;
    $[18] = control;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== isLoading || $[23] !== texts.cta) {
    t8 = <Button fullWidth={true} loading={isLoading} type="submit" size="large" data-dd-action-name="phone:continue">{texts.cta}</Button>;
    $[22] = isLoading;
    $[23] = texts.cta;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t4 || $[26] !== t7 || $[27] !== t8) {
    t9 = <form className="grid gap-6" onSubmit={t4}>{t7}{t8}</form>;
    $[25] = t4;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default PhoneForm;